import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

class CoveCompleteLook extends HTMLElement {
  #abort;
  connectedCallback() {
    this.#abort = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#update, { signal: this.#abort.signal });
  }
  disconnectedCallback() {
    this.#abort?.abort();
  }
  #update = (event) => {
    if (!event.promise) return;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || !detail?.html) return;
      if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = detail.html.getElementById(this.id);
      if (replacement) morph(this, replacement, { childrenOnly: true });
    }).catch(() => {});
  };
}
if (!customElements.get('cove-complete-look')) customElements.define('cove-complete-look', CoveCompleteLook);
